import { RadioOption } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

export function getEmailNotificationSubheader(
  sendLocWelcomeEmail: RadioOption
): string {
  return sendLocWelcomeEmail === RadioOption.YES
    ? 'Send email when credit becomes available'
    : 'Don’t send email when credit becomes available';
}
